import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
export function TopFlashBar() {
  const [timeLeft, setTimeLeft] = useState(29 * 60 + 47);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => setTimeLeft(t => Math.max(0, t - 1)), 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <AnimatePresence data-id="element-335">
      <motion.div initial={{
      y: -50,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} className="fixed top-0 left-0 right-0 z-50 bg-[var(--bg-elevated)] text-[var(--text-heading)] shadow-sm border-b border-[var(--border-subtle)]" data-id="element-336">
        <div className="max-w-7xl mx-auto px-3 py-2 sm:py-2.5 flex flex-wrap items-center justify-center gap-1.5 sm:gap-4 relative z-10 text-[10px] sm:text-xs font-medium text-center" data-id="element-337">
          <div className="flex items-center gap-1.5 flex-shrink-0" data-id="element-338">
            <AlertTriangle className="w-3.5 h-3.5 text-[var(--red-emphasis)] flex-shrink-0" data-id="element-339" />
            <span className="uppercase tracking-wider font-bold text-[var(--red-emphasis)]" data-id="element-340">
              LIMITED TIME OFFER
            </span>
          </div>
          <span className="hidden sm:inline opacity-40" data-id="element-341">—</span>
          <span className="opacity-90 flex-shrink-0 font-[400]" data-id="element-342">
            Get the 'Sensory Feeding Victory' for $6.99.
          </span>
          
        </div>
      </motion.div>
    </AnimatePresence>;
}